import { render, staticRenderFns } from "./Contract.vue?vue&type=template&id=60610f68&scoped=true&"
import script from "./Contract.vue?vue&type=script&lang=js&"
export * from "./Contract.vue?vue&type=script&lang=js&"
import style0 from "./Contract.vue?vue&type=style&index=0&id=60610f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60610f68",
  null
  
)

component.options.__file = "Contract.vue"
export default component.exports